
import { Movie, MoviesByDirector } from "@/types/movie";

// Constants for undo actions
export const UNDO_DURATION = 3000; // 3 seconds undo window

// Group movies by director 
export const groupMoviesByDirector = (movies: Movie[]): MoviesByDirector => {
  return movies.reduce((acc, movie) => {
    const { director } = movie;
    if (!acc[director]) {
      acc[director] = [];
    }
    acc[director].push(movie);
    return acc;
  }, {} as MoviesByDirector);
};

// Sort movies within each director by year (newest first), with popularity tiebreaker for same year
export const sortMoviesByYear = (movies: MoviesByDirector): MoviesByDirector => {
  Object.keys(movies).forEach(director => {
    movies[director].sort((a, b) => {
      // Primary sort: Year (descending) - newest first
      if (b.year !== a.year) {
        return b.year - a.year;
      }
      // Secondary sort: Popularity (descending) - higher popularity first for same year
      const aPopularity = a.popularity || 0;
      const bPopularity = b.popularity || 0;
      return bPopularity - aPopularity;
    });
  });
  return movies;
};

// Organize movies into groups by director and sorted by year with popularity tiebreaker
export function organizeMoviesByDirector(movies: Movie[]): MoviesByDirector {
  const grouped = groupMoviesByDirector(movies);
  return sortMoviesByYear(grouped);
}
